__turbopack_context__.v({
  "close": "ComparingModal-module-scss-module__6qRuEq__close",
  "comparingsWrapper": "ComparingModal-module-scss-module__6qRuEq__comparingsWrapper",
  "consideration": "ComparingModal-module-scss-module__6qRuEq__consideration",
  "content": "ComparingModal-module-scss-module__6qRuEq__content",
  "credit": "ComparingModal-module-scss-module__6qRuEq__credit",
  "cta": "ComparingModal-module-scss-module__6qRuEq__cta",
  "delete": "ComparingModal-module-scss-module__6qRuEq__delete",
  "deleteAll": "ComparingModal-module-scss-module__6qRuEq__deleteAll",
  "overlay": "ComparingModal-module-scss-module__6qRuEq__overlay",
  "overlayVisible": "ComparingModal-module-scss-module__6qRuEq__overlayVisible",
  "payment": "ComparingModal-module-scss-module__6qRuEq__payment",
  "program": "ComparingModal-module-scss-module__6qRuEq__program",
  "rate": "ComparingModal-module-scss-module__6qRuEq__rate",
  "revert": "ComparingModal-module-scss-module__6qRuEq__revert",
  "revertSvg": "ComparingModal-module-scss-module__6qRuEq__revertSvg",
  "title": "ComparingModal-module-scss-module__6qRuEq__title",
  "toolbar": "ComparingModal-module-scss-module__6qRuEq__toolbar",
  "top": "ComparingModal-module-scss-module__6qRuEq__top",
});
